import { useParams } from 'react-router-dom';
import { TransactionChats, formatBalance, formatDate } from '@ui/src';
import { useAppSelector } from '@store';
import { useCreateProblemTransactionChatMutation } from '../store/services/customers';

const InternalTransactionChats = () => {
  const {
    customersProblemTransactions: {
      internal: {
        transaction,
        chats,
        senderCompanyOfficials,
        recipientCompanyOfficials,
      },
    },
    customersDictionaries: {
      currentEmployee,
      currenciesList,
      activePermissions,
    },
  } = useAppSelector((state) => state);

  const [createTransactionChat, { isLoading: chatCreateInProgress }] =
    useCreateProblemTransactionChatMutation();

  const { transactionId } = useParams();

  const onCreateTransactionChat = (
    userIds?: string[],
    type?: 'recipient' | 'sender',
  ) => {
    const title = `RFI: Internal transaction ${formatBalance(
      transaction?.sum || 0,
      currenciesList?.find((item) => item.id === transaction?.currencyId),
    )} ${transaction?.currency?.name} ${
      transaction?.transferDate ? formatDate(transaction?.transferDate) : ''
    }`;

    if (!userIds?.length) {
      createTransactionChat({
        id: transactionId as string,
        body: {
          title,
          employeeId: currentEmployee?.id as string,
          organizationId:
            type === 'recipient'
              ? transaction?.recipientAccount?.organizationId
              : transaction?.senderAccount?.organizationId,
        },
      });
    } else {
      Promise.all(
        userIds.map((item) =>
          createTransactionChat({
            id: transactionId as string,
            body: {
              title,
              employeeId: currentEmployee?.id as string,
              organizationId:
                type === 'recipient'
                  ? transaction?.recipientAccount?.organizationId
                  : transaction?.senderAccount?.organizationId,
              userId: item,
            },
          }),
        ),
      );
    }
  };

  return (
    <TransactionChats
      chats={chats}
      individualCustomer={transaction?.senderAccount}
      onCreateTransactionChat={onCreateTransactionChat}
      chatCreateInProgress={chatCreateInProgress}
      currentEmployee={currentEmployee}
      recipients={recipientCompanyOfficials}
      senders={senderCompanyOfficials}
      recipientAccount={transaction?.recipientAccount}
      senderAccount={transaction?.senderAccount}
      activePermissions={activePermissions}
      internal
    />
  );
};

export default InternalTransactionChats;
